import React from 'react';
import PageWrapper from './PageWrapper';

interface Section {
    id: string;
    title: string;
    content: React.ReactNode;
}

interface LegalPageLayoutProps {
    pageTitle: string;
    sections: Section[];
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ pageTitle, sections }) => {
    return (
        <PageWrapper>
            <div className="py-20 sm:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto">
                        <div className="text-center mb-16">
                            <h1 className="text-4xl md:text-5xl font-extrabold text-[var(--text-primary)]">
                                {pageTitle}
                            </h1>
                        </div>

                        {/* Main Content */}
                        <main>
                            <div className="prose prose-invert max-w-none 
                                            prose-h2:text-[var(--text-primary)] prose-h2:border-b prose-h2:border-[var(--border-color)] prose-h2:pb-2
                                            prose-p:text-[var(--text-secondary)] prose-p:leading-relaxed
                                            prose-strong:text-[var(--text-primary)]
                                            prose-ul:text-[var(--text-secondary)] prose-ul:space-y-2
                                            prose-a:text-[var(--gradient-to)] hover:prose-a:text-[var(--gradient-from)]
                                            prose-li:marker:text-[var(--text-secondary)]">
                                {sections.map(section => (
                                    <section key={section.id} id={section.id} className="mb-12 scroll-mt-24">
                                        <h2>{section.title}</h2>
                                        {section.content}
                                    </section>
                                ))}
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default LegalPageLayout;